import React, { useContext, useRef, useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Checkbox } from '../../Checkbox';
import { RadioButton } from '../../RadioButton';
import useIsMobile from '../../Utils/customHooks/useIsMobile';
import { ListContext } from '../context';
import { ListSelectionTypes } from '../helper';
import moduleStyles from '@dtsl/css-list/dist/index.module.css';
function ListItem(props) {
  const {
    children,
    selectionIdentifier,
    onChange,
    listDefaultChecked = false,
    index: itemIdx,
    isSelected = false,
    disabled = false,
    item = {}
  } = props;
  const {
    isMobile: isMobileView
  } = useIsMobile(640);
  const {
    isMobile: isTabletView
  } = useIsMobile(1024);
  const {
    listSelectionType
  } = useContext(ListContext);
  const listItemRef = useRef();
  const listItemClasses = classNames({
    [moduleStyles['sib-list__item']]: true,
    [moduleStyles['locked']]: disabled,
    [moduleStyles['sib-list__item-xs']]: isMobileView,
    [moduleStyles['sib-list__item-selected']]: isSelected,
    [moduleStyles['sib-list__item-xs-radio-select']]: isMobileView && listSelectionType === ListSelectionTypes.SINGLE_SELECTION
  });
  const handleSingleSelect = e => {
    e.stopPropagation();
    onChange(e.target.checked, item);
  };
  const handleMultiSelect = e => {
    e.stopPropagation();
    onChange(e.target.checked, item);
  };
  useEffect(() => {
    var _listItemRef$current;
    const innerElements = listItemRef === null || listItemRef === void 0 ? void 0 : (_listItemRef$current = listItemRef.current) === null || _listItemRef$current === void 0 ? void 0 : _listItemRef$current.querySelectorAll('button, a');
    if (disabled) {
      innerElements === null || innerElements === void 0 ? void 0 : innerElements.forEach(elem => {
        elem.setAttribute('tabindex', -1);
      });
    } else {
      innerElements === null || innerElements === void 0 ? void 0 : innerElements.forEach(elem => {
        elem.removeAttribute('tabindex');
      });
    }
  }, [disabled, isTabletView, isMobileView]);
  return /*#__PURE__*/React.createElement("li", {
    ref: listItemRef,
    className: listItemClasses,
    tabIndex: disabled ? -1 : 0,
    role: "presentation"
  }, listSelectionType === ListSelectionTypes.SINGLE_SELECTION ? /*#__PURE__*/React.createElement(RadioButton, {
    identifier: selectionIdentifier,
    defaultChecked: listDefaultChecked,
    name: "listitem",
    disabled: disabled,
    controlStyles: {
      marginRight: 0
    },
    onChange: event => handleSingleSelect(event),
    onKeyDown: event => {
      if (event.which === 38 || event.which === 40) {
        handleSingleSelect(event, itemIdx);
      }
    }
  }) : null, listSelectionType === ListSelectionTypes.MULTI_SELECTION ? /*#__PURE__*/React.createElement(Checkbox, {
    ellipsis: true,
    disabled: disabled,
    identifier: selectionIdentifier,
    variant: "positive"
    // defaultChecked={listDefaultChecked}
    ,
    onChange: event => handleMultiSelect(event),
    onKeyDown: event => {
      if (event.which === 13 || event.which === 32) {
        handleMultiSelect(event);
      }
    },
    checked: isSelected
  }) : null, React.Children.map(children, (child, index) => {
    return /*#__PURE__*/React.cloneElement(child, {
      key: index,
      index
    });
  }));
}
ListItem.propTypes = {
  children: PropTypes.node.isRequired,
  selectionIdentifier: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  listDefaultChecked: PropTypes.bool,
  item: PropTypes.object,
  index: PropTypes.number,
  isSelected: PropTypes.bool,
  disabled: PropTypes.bool
};
export default ListItem;